import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button } from '@pattern-library/buttons';
import Banner from '@pattern-library/banner';

function SsoButton(props) {
    const [bannerEligibilityVisible, setBannerEligibilityVisible] = useState(false);
    const [bannerErrorVisible, setBannerErrorVisible] = useState(false);
    const [bannerProxiedAdminVisible, setBannerProxiedAdminVisible] = useState(false);
    const [samlResponse, setSamlResponse] = useState(null);
    const [arkPostUrl, setArkPostUrl] = useState(null);
    const [requesting, setRequesting] = useState(false);

    const requestSso = async () => {
        setRequesting(true);
        setBannerEligibilityVisible(false);
        setBannerErrorVisible(false);
        setBannerProxiedAdminVisible(false);
        let eligible = true;
        if (props.eligibilityAction) {
            let eligibilityResponse = await axios.post(props.baseUrl + '/participant/ArkSso/SsoEligibility?p=' + props.navigationKey, { action: props.eligibilityAction });
            if (!eligibilityResponse.data || eligibilityResponse.data?.error) {
                setBannerErrorVisible(true);
            }
            else if (!eligibilityResponse.data.eligible) {
                setBannerEligibilityVisible(true);
            }
            eligible = eligibilityResponse.data?.eligible ?? false;
        }
        if (eligible) {
            let ssoResponse = await axios.post(props.baseUrl + '/participant/ArkSso/SsoRequest?p=' + props.navigationKey, { arkDeeplinkUrl: props.arkDeeplinkUrl, dcaDeeplinkUrl: props.dcaDeeplinkUrl, webExperienceId: props.webExperienceId });
            if (ssoResponse.data?.SamlResponse && ssoResponse.data?.PostURL) {
                setSamlResponse(ssoResponse.data.SamlResponse);
                setArkPostUrl(ssoResponse.data.PostURL);
                setTimeout(() => document.ssoForm.submit(), 100);
            } else {
                setRequesting(false);
                if (ssoResponse.data?.Error === 'proxiedAdmin') {
                    setBannerProxiedAdminVisible(true);
                } else {
                    setBannerErrorVisible(true);
                }
            }
        }
    };

    return (
        <div className="ssoButton">
            <Button
                clickHandler={requestSso}
                customAttrs={{
                    'aria-label': props.buttonText
                }}
                text={props.buttonText}
                disabled={requesting}
                className="asc-mtb-2"
            />
            {bannerErrorVisible && (
                <Banner
                    id="errorBanner"
                    hasCloseButton
                    onClose={() => {
                        setBannerErrorVisible(false);
                    }}
                    message={<>An error occurred. Please try again later.</>}
                    type="warning"
                    customClass="asc-mtb-2"
                />
            )}
            {bannerEligibilityVisible && (
                <Banner
                    id="elgibilityBanner"
                    hasCloseButton
                    onClose={() => {
                        setBannerEligibilityVisible(false);
                    }}
                    message={<>{props.eligibilityText}</>}
                    customClass="asc-mtb-2"
                />
            )}
            {bannerProxiedAdminVisible && (
                <Banner
                    id="proxiedAdminBanner"
                    customClass="asc-mtb-2"
                    hasCloseButton
                    onClose={() => {
                        setBannerProxiedAdminVisible(false);
                    }}
                    message={<>This participant function is not available via proxy.</>}
                />
            )}
            {samlResponse && arkPostUrl && (
                <>
                    <form method="POST" name="ssoForm" action={arkPostUrl}>
                        <input type="hidden" name="SAMLResponse" value={samlResponse} />
                    </form>
                </>
            )}
        </div>
    );
}

SsoButton.propTypes = {
    navigationKey: PropTypes.string.isRequired,
    baseUrl: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    arkUrl: PropTypes.string.isRequired,
    dcaReturnUrl: PropTypes.string.isRequired,
    eligibilityAction: PropTypes.string,
    eligibilityText: PropTypes.string,
    webExperienceId : PropTypes.number
};

SsoButton.defaultProps = {
    eligibilitytext: 'You are not eligibile to perform this action.'
}

export default SsoButton;
